
import { useState, useCallback, useRef } from 'react';
import { UserCategory } from '@/types';

export const useCategoryState = () => {
  const [categories, setCategories] = useState<UserCategory[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [pendingOperationsCount, setPendingOperationsCount] = useState<number>(0);
  
  const setIsLoadingRef = useRef(setIsLoading);
  setIsLoadingRef.current = setIsLoading;

  const handleSetIsLoading = useCallback((loading: boolean) => {
    setIsLoadingRef.current(loading);
  }, []);

  const handleSetCategories = useCallback((newCategories: UserCategory[]) => {
    setCategories(newCategories);
  }, []);

  const handleCategoryAdded = useCallback((category: UserCategory) => {
    setCategories(prev => [...prev, category].sort((a, b) => (a.position || 0) - (b.position || 0)));
  }, []);

  const handleCategoryUpdated = useCallback((id: string, updates: Partial<UserCategory>) => {
    setCategories(prev =>
      prev.map(category =>
        category.id === id ? { ...category, ...updates } : category
      ).sort((a, b) => (a.position || 0) - (b.position || 0))
    );
  }, []);

  const handleCategoryDeleted = useCallback((id: string) => {
    setCategories(prev => prev.filter(cat => cat.id !== id));
  }, []);

  const mutateCategoryLocally = useCallback((id: string, updates: Partial<UserCategory>) => {
    setCategories(prev => {
      const updated = prev.map(cat =>
        cat.id === id ? { ...cat, ...updates } : cat
      );
      return [...updated]; // nuova reference = re-render garantito
    });

    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('categoriesSyncCompleted', {
        detail: { source: 'local-mutation', timestamp: Date.now() }
      }));
    }, 100);
  }, []);

  return {
    categories,
    setCategories: handleSetCategories,
    isLoading,
    setIsLoading: handleSetIsLoading,
    error,
    setError,
    pendingOperationsCount,
    setPendingOperationsCount,
    handleCategoryAdded,
    handleCategoryUpdated,
    handleCategoryDeleted,
    mutateCategoryLocally
  };
};
